var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M12 9.919a3.998 3.998 0 0 1 4-3.92c2.21 0 4 1.79 4 3.997a3.998 3.998 0 0 1-4 3.996 3.998 3.998 0 0 1-4-3.916.967.967 0 0 1-.28.612L7.685 14.71a.958.958 0 0 1-.686.285c-.536 0-.994-.461-.994-.997 0-.273.107-.528.283-.704l2.379-2.302H.98c-.537 0-.976-.46-.976-.996s.44-.992.976-.992h7.676L6.287 6.687a.957.957 0 0 1-.283-.686c0-.536.458-.996.994-.996.274 0 .51.1.686.285l4.027 4.024c.159.158.27.365.29.605Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowEnd);
export default __webpack_public_path__ + "static/media/flow-end.0bc9136cc7af90c3279c2279c4b2e77e.svg";
export { ForwardRef as ReactComponent };